<bn-loading-overlay></bn-loading-overlay>
<div class="table-responsive" *ngIf="limites && limites.length">
    <div *ngIf="ehFGBS" class="d-flex justify-content-end">
        <button class="btn btn-secondary m-0" type="button" (click)="btnExportarLimites()"
            placement="top" ngbTooltip="Exporta a pesquisa listada">
        <i class="fa fa-file"></i> Exportar limites</button>
    </div>
    <div *ngIf="dataLimites" class="letra-miuda">
        Consulta realizada em: {{ dataLimites }}
    </div>
    <table class="table table-hover">
        <thead>
        <tr>
            <th *ngIf="limites[0].agenteFinanceiro?.nome">Agente Financeiro</th>
            <th class="titulo-moeda">Limite vigente</th>
            <th *ngIf="tranche.indicadorLimiteEspecialHabilitado" class="titulo-moeda">Limite máximo</th>
            <th class="titulo-moeda">Valor utilizado</th>
            <th class="titulo-moeda">Valor disponível</th>
            <th *ngIf="limiteEspecialAtivo" class="titulo-moeda">Limite Especial</th>
            <th *ngIf="limiteEspecialAtivo" class="titulo-moeda">Especial utilizado</th>
            <th *ngIf="limiteEspecialAtivo" class="titulo-moeda">Especial disponível</th>
            <th *ngIf="permiteEdicao"></th>
            <th *ngIf="permiteEdicao"></th>
        <tr>
        </thead>
        <tbody>
        <tr *ngFor="let limite of limites" [ngClass]="getDestaqueLimite(limite)">
            <td *ngIf="limites[0].agenteFinanceiro?.nome">
                {{limite.agenteFinanceiro?.nome}}
            </td>
            <td class="moeda">
                <ng-container *ngIf="existeLimiteAgenteFinanceiroTranche && !ehFGBS">
                    {{limite.valorLimite.valorLimiteTotal | bnMask:'MOEDA'}}
                </ng-container>
                <ng-container *ngIf="!existeLimiteAgenteFinanceiroTranche || ehFGBS">
                    N/A
                </ng-container>                
            </td>
            <td *ngIf="tranche.indicadorLimiteEspecialHabilitado" class="moeda">
                {{limite.valorLimiteMaximo  | bnMask:'MOEDA'}}
            </td>
            <td class="moeda">
                {{limite.valorLimite.valorLimiteUtilizado | bnMask:'MOEDA'}}
            </td>
            <td [ngClass]="'moeda' + ( limite.valorLimite.valorLimiteDisponivel < 0.00 ? ' negativo' : '' )">
                <ng-container *ngIf="existeLimiteAgenteFinanceiroTranche && !ehFGBS">
                    {{limite.valorLimite.valorLimiteDisponivel | bnMask:'MOEDA'}}
                </ng-container>
                <ng-container *ngIf="!existeLimiteAgenteFinanceiroTranche || ehFGBS">
                    N/A
                </ng-container>
            </td>
            <td *ngIf="limiteEspecialAtivo" class="moeda">
                {{limite.valorLimiteEspecial?.valorLimiteTotal | bnMask:'MOEDA'}}
            </td>
            <td *ngIf="limiteEspecialAtivo" class="moeda">
                {{limite.valorLimiteEspecial?.valorLimiteUtilizado | bnMask:'MOEDA'}}
            </td>
            <td *ngIf="limiteEspecialAtivo" class="moeda">
                {{limite.valorLimiteEspecial?.valorLimiteDisponivel | bnMask:'MOEDA'}}
            </td>
            <td *ngIf="permiteDetalhe && existeLimiteAgenteFinanceiroTranche">
                <a class="cursor-pointer" (click)="visualizarLimite(limite)">
                    <i class="fa fa-search cursor-pointer"
                    ngbTooltip="Visualizar detalhe"
                    aria-hidden="true"></i>
                </a>
            </td>
            <td *ngIf="permiteEdicao && trancheAtiva && existeLimiteAgenteFinanceiroTranche">
                <a class="cursor-pointer" (click)="editarLimite(limite)">
                    <i class="fa fa-pencil cursor-pointer"
                    ngbTooltip="Editar limite"
                    aria-hidden="true"></i>
                </a>
            </td>
        </tr>
        </tbody>
    </table>
</div>
